export enum MilestoneHideStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
